// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:1180px){.notifications-list[data-v-6597aa00]{overflow:hidden}}", ""]);
// Exports
module.exports = exports;
